import t, { css as o } from "styled-components";
import { DEVICE as p } from "../../../constants/breakpoint.es.js";
import { Tooltip as s } from "../Tooltip/Tooltip.es.js";
import { Radio as a } from "../../Inputs/Option/Radio.es.js";
import { Image as r } from "../Image/Image.es.js";
const I = t.div.withConfig({
  displayName: "SegmentedCardOptions",
  componentId: "sc-11t05iw-0"
})(["display:flex;flex-direction:row;gap:40px;justify-content:center;width:100%;@media (max-width:1199px){flex-direction:column;align-items:flex-start;}", ""], ({
  $isActive: e
}) => e && o(["", "{align-items:flex-start;flex-direction:column;}"], p.mobile.max));
var n;
const b = t.div.withConfig({
  displayName: "SegmentedCardItem",
  componentId: "sc-11t05iw-1"
})(["align-items:flex-start;background:var(--color-bg-default);border:1px solid var(--color-border-default);border-radius:var(--size-border-radius-md);cursor:pointer;display:flex;flex-direction:row;height:auto;padding:16px;position:relative;transition:all 0.3s ease-in-out;width:100%;.segmented-card-radio{position:absolute;top:8px;left:8px;}", "{width:100%;}", " ", " ", " &:hover{background:var(--color-bg-default);border:1px solid var(--color-border-strong);", " ", "}.radio-input{display:flex;height:28px;}.radio-description{color:var(--color-neutral-800);font-size:16px;font-style:normal;font-weight:normal;line-height:150%;text-align:left;}"], (n = s.S) == null ? void 0 : n.Tooltip, ({
  $isActive: e
}) => e && o(["background:var(--color-bg-default);border:2px solid var(--color-accent-primary-default);"]), ({
  $disabled: e
}) => e && o(["cursor:not-allowed;opacity:0.4;pointer-events:all !important;"]), ({
  $error: e
}) => {
  var i, d;
  return e && o(["background:var(--color-bg-default);border:2px solid var(--color-error-default);", "{border-color:var(--color-error-default) !important;}", "::after{background-color:var(--color-error-default) !important;}"], (i = a.S) == null ? void 0 : i.InputCheckmark, (d = a.S) == null ? void 0 : d.InputCheckmark);
}, ({
  $isActive: e
}) => e && o(["border:2px solid var(--color-border-strong);"]), ({
  $error: e
}) => e && o(["background:var(--color-bg-default);border:2px solid var(--color-error-default);"]));
var l, m;
const g = t.div.withConfig({
  displayName: "SegmentedCardItemContent",
  componentId: "sc-11t05iw-2"
})(["align-items:center;display:flex;flex-direction:column;height:176px;margin-top:24px;width:100%;", "{object-fit:contain;}", "{", "{display:none;}}"], (l = r.S) == null ? void 0 : l.Image, p.mobile.max, (m = r.S) == null ? void 0 : m.Image), f = t.div.withConfig({
  displayName: "SegmentedCardItemHeaderTop",
  componentId: "sc-11t05iw-3"
})(["align-items:center;display:flex;flex-direction:column;flex-grow:1;gap:8px;width:100%;", ""], ({
  $direction: e
}) => e === "horizontal" && o(["flex-direction:row;min-height:70px;"]));
var c;
const v = t.div.withConfig({
  displayName: "SegmentedCard",
  componentId: "sc-11t05iw-4"
})(["", " ", "{", "}", "{", "}"], g, (c = r.S) == null ? void 0 : c.Image, ({
  isSelected: e
}) => e && o(["display:none;"]), f, ({
  isSelected: e
}) => e && o(["height:auto;"])), y = t.div.withConfig({
  displayName: "SegmentedCardItemHeaderBody",
  componentId: "sc-11t05iw-5"
})(["display:flex;flex-direction:column;gap:4px;width:100%;"]), S = t.div.withConfig({
  displayName: "SegmentedCardContent",
  componentId: "sc-11t05iw-6"
})(["margin-top:", ";"], ({
  isPage: e
}) => e ? "16px" : "0"), k = t.div.withConfig({
  displayName: "SegmentedCardItemHeader",
  componentId: "sc-11t05iw-7"
})(["display:flex;flex-direction:column;gap:16px;width:100%;"]), N = t.div.withConfig({
  displayName: "SegmentedCardItemHeaderBottom",
  componentId: "sc-11t05iw-8"
})(["width:100%;"]);
export {
  v as SegmentedCard,
  S as SegmentedCardContent,
  b as SegmentedCardItem,
  g as SegmentedCardItemContent,
  k as SegmentedCardItemHeader,
  y as SegmentedCardItemHeaderBody,
  N as SegmentedCardItemHeaderBottom,
  f as SegmentedCardItemHeaderTop,
  I as SegmentedCardOptions
};
//# sourceMappingURL=style.es.js.map
